import { h, Component } from 'preact';
import { route } from 'preact-router';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import { Loading } from 'lib/mkjs';

import ContactInfo from "entities/contactinfo";
import Connection from "entities/connection";

import { getConnectionRequestUrl } from '../connectionrequest';

import { getIdentity, getVerification } from "entities/contactinfo";

import style from './style.less';

function renderContactViewImage(subject) {
	return <div class={style.contact_view_image}>
	</div>
}

function renderContactViewHeadline(subject) {
	//TODO centralize logic
	return <div class={style.contact_view_headline_container}>
		<div class={style.contact_view_headline}>
			{subject.info ? subject.info.name : 'no name'}
		</div>
	</div>
}

function renderSingleContactField(icon, value) {
	return <div>
		<label><i class={"fa fa-" + icon}></i></label>
		<div class={style.contact_view_value}>{value || <span class="text-muted font-italic">empty</span>}</div>
	</div>
}

function renderEmails(email) {
	return renderSingleContactField('at',email)
}

function renderPhoneNumbers(phone) {
	return renderSingleContactField('phone',phone)
}

function renderAddresses(subject) {
	const {
		address1,
		address2,
		city,
		state,
		zip
	} = subject.info;
	const cityStateZip = [(city ? city + ',' : null), state, zip].join(' ')
	let val = [address1, address2, cityStateZip].filter(v=>v!=null && v.trim().length > 0);
	return renderSingleContactField('map-marker', val.length > 0
		? <div>{val.map(line=><div>{line}</div>)}</div>
		: null)
}

class SingleContactView extends ContactInfo {
	getName() {
		return 'contactInfo';
	}

	renderView(subject) {
		subject.info || (subject.info = {});
		return <div class={style.contact_detail}>
			<div class={style.single_contact_header}>
				{renderContactViewImage(subject)}
				{renderContactViewHeadline(subject)}
			</div>
			{this.renderActions(subject)}
			{renderEmails(this.renderDisplayValueEmail(subject.info.email))}
			{renderPhoneNumbers(this.renderDisplayValuePhone(subject.info.phone))}
			{renderAddresses(subject)}
		</div>
	}

	renderActions(subject) {

	}

	renderDisplayValueEmail(val) {
		if (!val) return null;
		let link = this.renderDisplayValueLink(val, 'mailto:' + val);
		if (this.getIdentity("EMAIL", val)) {
			link = <div>{link} <i class="fa fa-shield" aria-hidden="true" title="verified"></i></div>;
		}
		return link;
	}

	renderDisplayValuePhone(val) {
		if (!val) return null;
		let link = this.renderDisplayValueLink(val, 'tel:' + val);
		if (this.getIdentity("PHONE_NUMBER", val)) {
			link = <div>{link} <i class="fa fa-shield" aria-hidden="true" title="verified"></i></div>;
		}
		return link;
	}

	renderDisplayValueLink(text, href) {
		return href
			? <a href={href} target="_blank">{text}</a>
			: text;
	}

	renderDisplayValueLocation() {
		//TODO add link to map
	}
}

class PersonalContactView extends SingleContactView {

	getEditTitle(isUpdate, entity) {
		return (isUpdate ? 'update ' : 'new ') + this.getDisplayName(entity);
	}

	getDisplayName(entity) {
		return 'personal contact';
	}

	onClickDelete(subject){
		if (window.confirm("Are you sure you want to permanently delete this contact?")) {
			this.submitDelete(subject);
		}
	}

	onClickClear(subject){
		if (window.confirm("Are you sure you want to clear your info?")) {
			this.submitUpdate(subject.id, { info: {} });
		}
	}

	renderActions(subject) {
		// TODO connection request button should be decorated if the request exists?
		const actions = [
			<button type="button" class="btn btn-sm btn-mkjs-primary" onClick={()=>console.log('TODO')}>edit photo</button>,
			<a class="btn btn-sm btn-mkjs-primary" href={this.getEditUrl(subject)}>edit info</a>
		];
		if (!this.props.connection) {
			actions.push(<a class="btn btn-sm btn-mkjs-primary" href={getConnectionRequestUrl(subject.id)}>send request</a>);
			actions.push(<a class="btn btn-sm btn-mkjs-primary" href="#" onClick={()=>this.onClickDelete(subject)}>delete</a>);
		} else {
			actions.push(<a class="btn btn-sm btn-mkjs-primary" href="#" onClick={()=>this.onClickClear(subject)}>clear my notes</a>);
		}
		return h('div', { class: "btn-group " + style.action_buttons }, actions);
	}

	renderCreate() {
		return <div>
			<div class="pull-right pt-2">
				<a class={"btn btn-info " + style.header_button} href="/import">import...</a>
			</div>
			{super.renderCreate()}
		</div>
	}

	prepareCreate(subject) {
		return {
			info: subject,
			owner: this.props.contactEntity
		}
	}

	getViewUrl(entity) {
		return getContactViewUrl(entity);
	}

	getEditUrl(entity) {
		return this.getViewUrl(entity) + '/edit';
	}
}

function getContactViewUrl(entity) {
	return '/contacts/' + entity.id;
}

class MyContactInfoView extends PersonalContactView {
	getDisplayName() {
		return 'my contact info';
	}

	getViewUrl(item=this.state.subject) {
		return '/me';
	}

	getEditUrl(entity) {
		return this.getViewUrl(entity) + '?edit';
	}

	renderActions(subject) {
		return <div class={"btn-group " + style.action_buttons}>
			<button type="button" class="btn btn-sm btn-mkjs-primary" onClick={()=>console.log('TODO')}>photo</button>
			<a class="btn btn-sm btn-mkjs-primary" href={this.getEditUrl(subject)}>edit info</a>
		</div>
	}

	renderDisplayValueEmail(val) {
		if (!val) return null;
		const type = 'EMAIL';
		const identity = getIdentity(type, val, this.props.contactEntity);
		const identityRequest = getVerification(type, val, this.props.contactEntity);
		let link = this.renderDisplayValueLink(val, 'mailto:' + val);
		if (identity) {
			//TODO create user's identities page; ability to highlight one identity in particular
			link = <div>
				{link} <a href={getVerifyIdentityUrl(type, val)}><i class="fa fa-shield" aria-hidden="true" title="verified"></i></a>
			</div>;
		} else if (identityRequest) {
			link = <div>
				{link} (<a href={getVerifyIdentityUrl(type, val)}>verification pending</a>)
			</div>;
		} else {
			link = <div>
				{link} (<a href={getVerifyIdentityUrl(type, val)}>verify</a>)
			</div>;
		}
		return link;
	}

	//TODO add phone number, or parameterize these verifiable info values
}

class ConnectionContactInfo extends SingleContactView {
	userCan(action) {
		return action === 'get';
	}

	getDisplayName(entity) {
		return entity.info.name || 'Connection Information';
	}

	renderActions(subject) {
		// TODO connection request button should be decorated if the request exists?
		if (this.props.actions && Object.keys(this.props.actions).length) {
			return <div class={"btn-group " + style.action_buttons}>
				{
					Object.keys(this.props.actions).map(actionName=><button type="button"
						class="btn btn-sm btn-mkjs-primary"
						onClick={this.props.actions[actionName]}>{actionName}</button>)
				}
			</div>
		}

	}
}

class ContactInfoPage extends Component {
	render() {
		if (this.props.isLoading) {
			return <Loading />
		} else if (!this.props.contactEntity) {
			return <Error />
		} else {
			return <ContactInfoPageInternal {...this.props} />
		}
	}
}

class ContactInfoPageInternal extends ContactInfo {

	getDisplayName(entity) {
		return 'personal contact';
	}

	fetch(id) {
		return this.getApi().get(id + "/for/" + this.props.contactEntity.id)
	}

	renderView(subject) {
		return <ConnectionViewPage subject={subject} onUpdate={()=>this.fetchSubject()} {...this.props} />
	}
}

class ConnectionPage extends Component {
	render() {
		if (this.props.isLoading) {
			return <Loading />
		} else if (!this.props.contactEntity) {
			return <Error />
		} else {
			return <ConnectionPageInternal {...this.props} />
		}
	}
}

class ConnectionPageInternal extends Connection {
	fetch(id) {
		return this.getApi().get(id + "/for/" + this.props.contactEntity.id)
	}

	renderView(subject) {
		return <ConnectionViewPage subject={subject} onUpdate={()=>this.fetchSubject()} {...this.props} />
	}
}

function contactInfoIsEmpty(contactInfo) {
	return !contactInfo || !contactInfo.info || !Object.values(contactInfo.info).some(a=>!!a);
}

class ConnectionViewPage extends Component {
	removeConnection({ connection, personalContactInfo }, deletePersonal = false){
		if (window.confirm("Are you sure you want to permanently delete this connection?")) {
			this.props.apis.connection.delete(connection).then(() => {
				if (personalContactInfo && personalContactInfo.id) {
					if (deletePersonal || contactInfoIsEmpty(personalContactInfo)) {
						this.props.apis.contactInfo.delete(personalContactInfo).then(() => {
							route('/');
						});
					} else {
						route(getContactViewUrl(personalContactInfo));
					}
				} else {
					route('/');
				}
			});
		}
	}
	render() {
		const connectionView = this.props.subject;
		return <section>
			{ connectionView.connection
				? <ConnectionContactInfo subject={connectionView.connectionContactInfo} actions={{
						'disconnect': ()=>this.removeConnection(connectionView),
						'delete completely': ()=>this.removeConnection(connectionView, true)
					}} />
				: null
			}
			{ connectionView.personalContactInfo
				? <PersonalContactView {...this.props}
						subject={connectionView.personalContactInfo}
						connection={connectionView.connection} onDelete={()=>route('/')} forceRefresh/>
				: null }
		</section>
	}
}

function getVerifyIdentityUrl(type, val) {
	return `/me/verify/${type}/${encodeURIComponent(val)}`
}

export {
	ContactInfoPage,
	ConnectionPage,
	MyContactInfoView,
	PersonalContactView,
	getVerifyIdentityUrl,
	contactInfoIsEmpty
}



// WEBPACK FOOTER //
// ./components/elements/contactview/index.js